module.exports = __webpack_public_path__ + "static/img/wangzhan_title.e65140a.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/wangzhan_title.png
// module id = 9Lrz
// module chunks = 0